import React from "react"

function Tags(props){
    const {content, randomColors, glow} = props
    let contentTags = []
    // console.log('glow',glow);
    return content.map((text, i) => {
        let randomColor = randomColors[Math.floor(Math.random()*randomColors.length)]
        let boxShadow = (glow === undefined || glow === true) ? `0 0 10px ${randomColor}` : "none"
        return (
            <div className="tag" key={i} style={{ color: randomColor, borderColor: randomColor, boxShadow: boxShadow }}>{text}</div>
        )
    })
}

export default Tags
